import React, { Component } from 'react';
import { withRouter }       from 'react-router';
import { connect }          from 'react-redux';
import { Navbar, Nav,
         NavDropdown }      from 'react-bootstrap';
import Sticky               from 'react-stickynode';
import { isLoggedIn }       from '../../../utils/authService';
import Login                from '../../Login';
import { AwsConstants }     from '../../../utils/environment';
import { ribbonFetchData }  from '../../../actions/core/ribbon';

import 'bootstrap/dist/css/bootstrap.min.css';

var apiHost = AwsConstants.WebApiHost;

class Header extends Component {
  
  componentDidMount() {
    //if (isLoggedIn()) {
      this.props.fetchData(apiHost);
    //}
  }
  
  render() {
    return (
      <Sticky>
        <Navbar className='navbar-default' bg='light'>
          <div className='container'>
            <Navbar.Brand>
              <a href="/" rel="home">
                <img
	          alt="Boise State University logo"
                  src="https://www.boisestate.edu/wp-content/themes/core/img/theme/logos/boisestate-b-logo.svg"
                  width="30"
                  height="30"
                  className="d-inline-block align-top"
	          aria-label="Boise State University logo"
                />
              </a>
            </Navbar.Brand>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <NavDropdown title="Services" id="basic-nav-dropdown">
                  {this.props.ribbon.length > 0 ?
                    this.props.ribbon.map((r, index) => (
                      <NavDropdown.Item key={index} href={"/#" + r.path}>{r.name}<i style={{ marginLeft: '2px' }} className={r.icon}></i></NavDropdown.Item>
                    ))
                    :
                    <Login />
                  }
                  {!isLoggedIn() ?
                    <Login />
                    :
                    <span />
                  }
                </NavDropdown>
              </Nav>
              <Nav><Login /></Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </Sticky>
    );
  }
}

const mapStateToProps = state => {
  return {
    ribbon: state.core.ribbon.ribbon,
    hasErrored: state.core.ribbon.ribbonHasErrored,
    isLoading: state.core.ribbon.ribbonIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host) => dispatch(ribbonFetchData(host))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
